import api from '../api/axios';
import { STAFF_ROLES } from '../config/features';

// Statuses a product can still be added to from a product page. QUOTE is locked (a quote has
// been sent); HOLD, LOST and CONVERTED are closed.
const OPEN_FOR_STAFF = ['CART', 'REQUESTED'];

/**
 * The curated carts the signed-in person can add a product to, newest first.
 *
 * - eYantra staff: their open carts — the ones they created or are the eYantra POC for (all
 *   open carts for ADMIN), from the same GET /quotes/all the Curated carts screen uses.
 *   /quotes/my-carts was wrong for staff: it lists carts where the signed-in person is the
 *   *client*, so staff never saw the carts they built ("No open curated carts").
 * - Customers: carts shared with them as the client (/quotes/my-carts), not yet quoted.
 */
export async function openCartsFor(user) {
  const staff = STAFF_ROLES.includes(user?.role);
  const res = await api.get(staff ? '/quotes/all' : '/quotes/my-carts');
  const carts = res.data || [];
  const open = staff ? carts.filter(c => OPEN_FOR_STAFF.includes(c.status)) : carts.filter(c => c.status !== 'QUOTE');
  const when = c => new Date(c.updatedAt || c.createdAt || 0).getTime();
  return open.sort((a, b) => when(b) - when(a));
}

/** "Cart name — Client" when the cart says who it's for. */
export const cartLabel = (cart) =>
  cart.quoteCreatedFor ? `${cart.cartName} — ${cart.quoteCreatedFor}` : cart.cartName;
